RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Alerts = Marionette.CollectionView.extend({
        childEvents: {
            destroy: 'onItemDestroy'
        },
        childView: views.Alert,
        className: 'alert-container',
        onItemDestroy: function (view) {

            const me = this;
            const model = view.model;
            const collection = me.collection;

            collection.remove(model);
        }
    });

});
